var map = {
	"./404.svg": 5548,
	"./activity.svg": 9427,
	"./birthday.svg": 775,
	"./bug.svg": 9443,
	"./case.svg": 9712,
	"./chart.svg": 5946,
	"./clipboard.svg": 2019,
	"./close.svg": 7807,
	"./component.svg": 2641,
	"./dashboard.svg": 2901,
	"./documentation.svg": 4109,
	"./drag.svg": 6541,
	"./edit.svg": 9687,
	"./education.svg": 9338,
	"./email.svg": 7204,
	"./example.svg": 8822,
	"./excel.svg": 7549,
	"./execution.svg": 2728,
	"./exit-fullscreen.svg": 1404,
	"./eye-open.svg": 7590,
	"./eye.svg": 5596,
	"./form.svg": 163,
	"./fullscreen.svg": 2701,
	"./gift.svg": 8708,
	"./guide.svg": 2463,
	"./icon.svg": 7602,
	"./international.svg": 3043,
	"./language.svg": 9603,
	"./link.svg": 7651,
	"./list.svg": 7946,
	"./lock.svg": 8119,
	"./message.svg": 6677,
	"./money.svg": 9015,
	"./move.svg": 1434,
	"./nested.svg": 2855,
	"./password.svg": 1299,
	"./pdf.svg": 4209,
	"./people.svg": 1148,
	"./peoples.svg": 3648,
	"./perfume.svg": 7490,
	"./qq.svg": 8677,
	"./question.svg": 1200,
	"./right.svg": 300,
	"./running.svg": 7294,
	"./search.svg": 696,
	"./shoes.svg": 8584,
	"./shopping.svg": 6523,
	"./size.svg": 6393,
	"./skill.svg": 4898,
	"./star.svg": 5041,
	"./tab.svg": 3903,
	"./table.svg": 4636,
	"./taobao.svg": 2180,
	"./task.svg": 3521,
	"./template.svg": 1936,
	"./theme.svg": 3438,
	"./todo.svg": 7531,
	"./tree-table.svg": 667,
	"./tree.svg": 8149,
	"./user.svg": 7838,
	"./vip-member-fill.svg": 3185,
	"./wechat.svg": 8690,
	"./zip.svg": 776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;